import { useSyncExternalStore } from 'react';

/**
 * Thème clair / sombre de l'application. CLAIR par défaut, quel que soit le réglage de la
 * tablette : le choix de l'opérateur (bouton soleil/lune) est mémorisé sur la tablette.
 *
 * Le thème est porté par `<html data-theme="…">` : les jetons de index.css en dépendent. Le script
 * en tête de public/index.html pose l'attribut AVANT le premier rendu (sans quoi l'app clignoterait
 * en clair au démarrage d'une tablette réglée en sombre) — même clé de stockage qu'ici.
 */
export const CLE_THEME = 'aqs.theme';

const COULEUR_BARRE = { clair: '#F2F2F7', sombre: '#000000' };

function lireStocke() {
  try { return localStorage.getItem(CLE_THEME) === 'sombre' ? 'sombre' : 'clair'; } catch { return 'clair'; }
}

let theme = typeof window === 'undefined' ? 'clair' : lireStocke();
const abonnes = new Set();
let minuteurBascule = null;

function appliquer(valeur, avecFondu) {
  const racine = document.documentElement;
  if (avecFondu) {
    racine.classList.add('aqs-bascule-theme');
    clearTimeout(minuteurBascule);
    minuteurBascule = setTimeout(() => racine.classList.remove('aqs-bascule-theme'), 360);
  }
  if (valeur === 'sombre') racine.setAttribute('data-theme', 'dark');
  else racine.removeAttribute('data-theme');
  // Barre d'état / de titre de la PWA installée, accordée au fond de l'app.
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', COULEUR_BARRE[valeur]);
}

if (typeof window !== 'undefined') appliquer(theme, false);

export function changerTheme(valeur) {
  if (valeur === theme) return;
  theme = valeur;
  try { localStorage.setItem(CLE_THEME, valeur); } catch { /* navigation privée */ }
  appliquer(valeur, true);
  abonnes.forEach((f) => f());
}

function abonner(f) {
  abonnes.add(f);
  return () => abonnes.delete(f);
}

/** @returns {['clair'|'sombre', () => void]} le thème courant et la bascule. */
export default function useTheme() {
  const courant = useSyncExternalStore(abonner, () => theme, () => theme);
  return [courant, () => changerTheme(courant === 'sombre' ? 'clair' : 'sombre')];
}
